/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrColumnWidth } from './igr-column-width';
import { ColumnWidth } from './ColumnWidth';
import { TypeRegistrar } from "igniteui-react-core";
var IgrColumnWidthModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnWidthModule() {
    }
    IgrColumnWidthModule.register = function () {
        TypeRegistrar.registerCons("IgrColumnWidth", IgrColumnWidth);
        TypeRegistrar.register("ColumnWidth", ColumnWidth.$type);
    };
    return IgrColumnWidthModule;
}());
export { IgrColumnWidthModule };
//# sourceMappingURL=igr-column-width-module.js.map
